package amazon.lastmile.inject

import app.nestbridge.feature.careteam.api.CareTeamApiClient
import app.nestbridge.feature.careteam.api.RemoteCareTeamApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteCareTeamApiClient::class)
public interface AppNestbridgeFeatureCareteamApiRemoteCareTeamApiClient {
  @Provides
  public fun provideRemoteCareTeamApiClientCareTeamApiClient(remoteCareTeamApiClient: RemoteCareTeamApiClient): CareTeamApiClient = remoteCareTeamApiClient
}
